function ResetTag() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-label="태그 초기화"
    >
      <desc>태그 초기화</desc>
      <g data-name="그룹 11774">
        <path fill="#fff" d="M0 0h16v16H0z" data-name="사각형 10133"></path>
        <path
          fill="#333"
          d="M8.242 3.001a5.063 5.063 0 00-5.236 4.895 5.2 5.2 0 001.3 3.715l-.672.1a.641.641 0 00-.526.732.632.632 0 00.618.548.654.654 0 00.092-.007l2.69-.414-.141-2.685a.632.632 0 00-.658-.608.638.638 0 00-.591.678l.036.7a3.9 3.9 0 01-.9-2.695 3.752 3.752 0 117.491.373 3.849 3.849 0 01-1.967 3.214.654.654 0 00-.253.872.622.622 0 00.551.338.6.6 0 00.3-.077 5.186 5.186 0 00-2.132-9.678z"
          data-name="패스 1070"
        ></path>
      </g>
    </svg>
  )
}

export default ResetTag
